import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-date',
  styleUrls: ['form-date.component.scss'],
  template: `
    <mat-form-field class="w-100">
      <mat-label>{{ to.placeholder }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [placeholder]="props.placeholder"
        [formControl]="formControl"
        [required]="props.required"
      />
      <mat-datepicker-toggle matSuffix [for]="picker" />
      <mat-datepicker #picker />
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatInputModule,
    MatDatepickerModule,
    ReactiveFormsModule,
  ],
})
export class FormlyCustomDateComponent extends FieldType<FieldTypeConfig> {
  dateMask = {
    mask: Date,
  };
}
